import React from "react";
import { Button } from "@telia/teddy";
import cn from "classnames";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { sendSMSOrSubmit } from "../../../../checkout/state/actions/transferOwnershipActions";
import {
    getCanSendTransferOrder,
    getHasSentTransferOrder,
} from "../../../../checkout/state/selectors/accountSelectors";
import { getFormById } from "../../../../checkout/state/selectors/formSelectors";
import TEXT from "../../../text-consts";
import "./RequestTransferOfOwnershipContinueButton.less";

interface StateProps {
    canSendTransferOrder: boolean;
    hasSentTransferOrder: boolean;
    phoneNumber: string;
}

type RequestTransferOfOwnershipContinueButtonProps = StateProps;

const RequestTransferOfOwnershipContinueButton: React.FC<RequestTransferOfOwnershipContinueButtonProps> = ({
    // Redux
    canSendTransferOrder,
    hasSentTransferOrder,
    phoneNumber,
}) => {
    const dispatch = useDispatch();

    return (
        <div
            className={cn({
                "request-tranfer-of-ownership-continue-button__hide": hasSentTransferOrder,
            })}
        >
            <Button
                onClick={() => dispatch(sendSMSOrSubmit(phoneNumber))}
                id={`continue-button-request-transfer-of-ownership`}
                disabled={!canSendTransferOrder}
            >
                {TEXT.REQUEST_TRANSFER_OF_OWNERSHIP.BUTTON_TEXT}
            </Button>
        </div>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    canSendTransferOrder: getCanSendTransferOrder(state),
    hasSentTransferOrder: getHasSentTransferOrder(state),
    phoneNumber: _get(getFormById(state, FORM_ID.TRANSFER_OWNERSHIP), "values.transfer.number", ""),
});

export default connect(mapStateToProps)(RequestTransferOfOwnershipContinueButton);
